import {
  // formatTime,
  // getMaxZIndex,
  // getSuccessData,
  getType,
  // isPhone,
  // operation,
  // showDialog,
  // touch,
  fnFormaMoney,
  fnFormatMoneyForWan,
  fnFormatMoneyForWanNoZero,

  fnAdd,
  fnSub,
  fnMul,
  fnDiv,
  fnStopBub,
  fnFormaStockNum,
  fnGetSubStr,
  fnShowImg,
  timeTrunName
} from './base'
import {backstageUrl, isDev,fileServerUrl,prewebUrl} from '../config/project-config'
import { Toast } from 'vant'
import { ucWebPath,ccWebPath } from '@/config/project-config'

const PlugIn = new Object(null);

PlugIn.install = function (Vue, option) {
  Vue.mixin({
    data () {
      return {
        backstageUrl,
        prewebUrl
      }
    },
    methods: {
      log (v) {   //如果是开发的时候就会进行输出打印
        isDev && console.log(v);
      },
      alert (v) { //如果是开发的时候就会进行弹窗提示
        isDev && alert(v)
      },
      /**
       * @param {String} url 路径
       * 后台给的图片地址可能不是全路径，则前端需要自己进行拼接而成
       * use method: this.getImageRightPath('/test.jpg');
       *  */
      getImageRightPath(url){
        return fileServerUrl + "/" + url
      },
      /**
       *
       * @param {Object | String} params
       */
      goPointPage (params = {}) {
        if (this.getType(params, 'json')) {
          this.$router.push(params)
        } else if (this.getType(params, 'string')) {
          this.$router.push(params)
        }
      },
      getType,
      // formatTime,
      // 获取当前页面的宽高度
      getScreenWH () {
        return {
          width: window.screen.width,
          height: window.screen.height
        }
      },
      // touch,
      // /** 获取当前页面z-index最高的层级 */
      // getMaxZIndex,
      // showDialog,
      // operation,
      // getSuccessData,
      // isPhone,
      // 校验是否登录
      fnCheckLogin (config) {
        var islogin = false
        var userInfo=this.$store.getters.getUserInfo
        if(userInfo!=null&&userInfo.id!=null){
          islogin = true
        } else {
          if(config&&config.jumpIndex==true){
            Toast('登录已超时')
            this.$router.push('/indwx')
          }else {
            Toast('登录已超时')
          }
        }
        return islogin
      },
      fnGotoUserCenter(config) { //跳转用户中心
        config?'':config={}
        var isLogin= this.fnCheckLogin();
        // 跳转到用户中心
        new XtLogin({
          to_login: isLogin?'0':'1',//是否需要登录
          self_redirect: config.self_redirect?config.self_redirect:'0',
          access_token: this.$store.getters.getToken,
          redirect_uri: `${ucWebPath}/tologin`,
          second_redirect_uri:config.second_redirect_uri?config.second_redirect_uri:'/index',
          state: config.state?config.state:'123456',
          sucessCallBack: config.sucessCallBack?config.sucessCallBack:()=>{},
          errorCallBack: config.errorCallBack?config.errorCallBack:(e)=> {
            if(e=='token已失效'||e=='无效的Token' || e == '登录失效，请重新登录'){
              setTimeout(this.$router.push('/logout'),1000)
            }
            Toast(e)
          }
        })
      },
      fnGotoCompanyCenter(config,callBack){ //跳转到企业中心
        config?'':config={}
        if(this.fnCheckLogin()){
            // 跳转到企业中心
            new XtLogin({
              self_redirect: config.self_redirect?config.self_redirect:'0',
              access_token: this.$store.getters.getToken,
              redirect_uri: `${ccWebPath}/user/toLogin`,
              second_redirect_uri:config.second_redirect_uri?config.second_redirect_uri:'/index',
              state: config.state?config.state:'123456',
              sucessCallBack: config.sucessCallBack?config.sucessCallBack:(e)=>{
                if (callBack) {
                  callBack.call()
                }
              },
              errorCallBack: config.errorCallBack?config.errorCallBack:(e)=> {
                // notification.error({message: '错误',description: e})
                if(e=='token已失效'||e=='无效的Token' || e == '登录失效，请重新登录'){
                  setTimeout(this.$router.push('/logout'),1000)
                }
                Toast(e)
              }
            })
          // }
        }
      },
      fnFormaMoney,
      fnFormatMoneyForWan,
      fnFormatMoneyForWanNoZero,
      fnAdd,
      fnSub,
      fnMul,
      fnDiv,
      fnStopBub,
      fnFormaStockNum,
      Toast,
      fnGetSubStr,
      fnShowImg,
      timeTrunName,
    }
  })
}

export default PlugIn;



// WEBPACK FOOTER //
// ./src/util/plugIn.js